<script setup lang="ts">
import { useModelWrapper } from './wrappers/helpers/useModelWrapper'
import { useI18n } from 'vue-i18n'
import BaseModal from './wrappers/BaseModal.vue'

const props = defineProps<{
  modelValue: boolean
}>()
const emit = defineEmits<{
  (e: 'confirmDelete'): void
  (e: 'update:modelValue'): void
}>()
const value = useModelWrapper(props, emit)

const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`form.${key}`)

const confirmDelete = () => {
  emit('confirmDelete')
}
</script>
<template>
  <BaseModal v-model="value">
    <template #title>
      <slot name="title">{{ label('promptDeleteActivityHeader') }}</slot>
    </template>

    <template #content>
      <slot name="content">
        {{ label('promptDeleteActivity') }}
      </slot>
    </template>
    <template #actions>
      <div align="right">
        <q-btn flat no-caps class="text-grey-7" :label="label('cancel')" v-close-popup />
        <q-btn
          @click="confirmDelete"
          flat
          no-caps
          class="text-negative"
          :label="label('delete')"
          v-close-popup
        />
      </div>
    </template>
  </BaseModal>
</template>
